(function (angular) {
    angular
        .module('one.admin')
        .controller('AddCountdownModuleModalController', AddCountdownModuleModalController);

    AddCountdownModuleModalController.$inject = ['$scope', '$uibModalInstance', 'ModuleService', 'params'];

    function AddCountdownModuleModalController($scope, $uibModalInstance, ModuleService, params) {
        $scope.module = {
            module_instance: {
                brand: 'default'
            }
        };

        angular.merge($scope, params);

        $scope.addCountdownModule = addCountdownModule;

        $scope.cancel = cancel;

        function addCountdownModule(data) {
            ModuleService.addModule(data).then(function (data) {
                $uibModalInstance.close(data);
            });
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})(angular);
